import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from './LanguageSwitcher';

export function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-custom/10 border-t border-gray-custom/10">
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col lg:flex-row justify-between items-center">
          <div className="text-light/60 text-sm mb-4 lg:mb-0 order-3 lg:order-1 mt-6 lg:mt-0">
            © {currentYear} jamnation.ch. All rights reserved.
          </div>
           <div className="flex flex-col lg:flex-row items-center lg:space-x-6 order-1 lg:order-2">
            <span className="text-light/60 font-tilt-warp text-2xl light mb-4 lg:mb-0">jamnation</span>
            <LanguageSwitcher />
          </div>
          <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-6 order-2 lg:order-3 mt-6 lg:mt-0">
            <Link
              to="/blog"
              className="text-sm text-light/60 hover:text-light transition-colors"
            >
              Blog
            </Link>
             <Link
              to="/contact"
              className="text-sm text-light/60 hover:text-light transition-colors"
            >
               {t('nav.contact')}
            </Link>
            <Link
              to="/imprint"
              className="text-sm text-light/60 hover:text-light transition-colors"
            >
              {t('nav.imprint')}
            </Link>
            <Link
              to="/privacy"
              className="text-sm text-light/60 hover:text-light transition-colors"
            >
              {t('nav.privacy')}
            </Link>
            <Link
              to="/terms-and-conditions"
              className="text-sm text-light/60 hover:text-light transition-colors"
            >
               {t('nav.termsAndConditions')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;